import { ReactElement, useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
/*
 * 読み上げ文の動的文字色変更
 */
export function ColorChangeText(
  props: Readonly<{
    text: string;
    color: string;
    classname: string;
    interval: number;
    onColorChangeTextComplete?: () => void;
  }>
): ReactElement {
  const [currentIdx, setCurrentIdx] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIdx((currentIdx) => {
        if (currentIdx >= props.text.length) {
          clearInterval(intervalId);
          setIsCompleted(true);
          return currentIdx;
        }
        return currentIdx + 1;
      });
    }, props.interval);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.text]);

  useEffect(() => {
    if (isCompleted && props.onColorChangeTextComplete) {
      props.onColorChangeTextComplete();
      setIsCompleted(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCompleted]);

  const TextColored = props.text.split("").map((char, index) => {
    const style = {
      color: index < currentIdx ? props.color : "inherit",
    };
    return (
      <span key={index} style={style}>
        {char}
      </span>
    );
  });
  return <Box className={props.classname}>{TextColored}</Box>;
}
